<template>
  <v-container tag="section">
    <material-wizard
      v-model="tab"
      :title="title"
      subtitle="Preencha as Informações para a ferramenta Perdas AIC."
      :available-steps="tabsLiberadas"
      :tabs="tabs"
      class="mx-auto"
      :loading="loading"
      :wizzard-mixins-on="true"
      @click:next="nextStep()"
      @click:prev="prevStep()"
    >
      <wizard-tabs ref="wizzardTabsREF" :tab="tab" @step-observer="updateTabStatus($event)" @update:tab="tab = $event" />
    </material-wizard>
  </v-container>
</template>
  
<script>
  import PerdasAicService from '@/services/PerdasAicService';
  import wizardMixins from '@/mixins/wizardMixins';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    components: {
      MaterialWizard: () => import('@/components/base/MaterialWizard.vue'),
      WizardTabs: () => import('@/components/perdasAic/WizardTabs.vue')
    },
    mixins: [wizardMixins, dateFormatterMixins],

    data: () => ({
      tabs: ['Início', '% de Depreciação e IR'],
      loading: false
    }),

    computed: {
      title() {
        return this.$route.params.id ? 'Editando Perdas AIC' : 'Adicionar Nova Perdas AIC';
      }
    },

    created() {
      this.$store.dispatch('clearPerdasAic');

      if (this.$route.params.id) this.getById(this.$route.params.id);
    },

    methods: {
      getById(id) {
        PerdasAicService.getById(id)
          .then((response) => {
            this.setDataInVuex(response.data.data);
          })
          .catch(() => {
            this.$toast.error('Erro ao recuperar perdas aic.', '', { position: 'topRight' });
          });
      },

      save() {
        const id = this.$route.params.id ?? null;
        const data = this.$refs.wizzardTabsREF.exportData();
        this.loading = true;

        PerdasAicService.salvar(data, id)
          .then(() => {
            this.$toast.success('Perdas AIC salvo com sucesso.', '', { position: 'topRight' });
            this.$router.replace({ name: 'Perdas AIC Histórico' });
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao salvar Perdas AIC.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      },

      setDataInVuex(item) {
        this.$store.dispatch('setPerdasAic', {
          /* Campos etapa 1 */
          titulo: item.titulo,
          obras: item.obras,
          centrosCusto: item.centros_custo,
          tipos: item.tipos,
          dataLancamentoInicio: this.getOnlyDateIgnoringTimestamp(item.data_lancamento_inicio),
          dataLancamentoFim: this.getOnlyDateIgnoringTimestamp(item.data_lancamento_fim),

          /* Campos etapa 2 */
          percentuais: JSON.parse(item.percentuais)
        });

        this.$forceUpdate();
      }
    }
  };
</script>
  